<template>
  <footer>
    <img src="../assets/images/logo_yostar.png" alt="" class="logo">
    <img src="../assets/images/logo_maoliang.png" alt="" class="logo maoliang">

    <div class="text">
      <!-- 利用規約    |    プライバシーポリシー    |    資金決済法に基づく表示    |    特定商取引法に基づく表 -->
      <div class="item">
        <router-link target="_blank" to="/terms_of_service">利用規約</router-link>
        <router-link target="_blank" to="/privacy_policy">プライバシーポリシー</router-link>
        <router-link target="_blank" to="/money_settlement">資金決済法に基づく表示</router-link>
        <router-link target="_blank" to="/specific_business">特定商取引法に基づく表示</router-link>
        <router-link target="_blank" to="/feedback">お問合せ</router-link>
      </div>
      <div class="box">
        <p>推奨年齢区分：12+</p>
      </div>
      <div class="copyright">
        <p>&copy;2019 Soul Games, Inc.</p>
        <p>&copy;2019 Yostar, Inc. All Rights Reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>
    export default {
        name: 'vfooter',
        data: () => ({})
    }
</script>

<style lang="scss" scoped>
  footer {
    width: 100%;
    padding: pxTorem(32px) 0 pxTorem(26px);
    background: #000000;
    text-align: center;
    font-size: 0;

    @media screen and (max-width: 600px) {
      padding: MpxTorem(24px) 0 MpxTorem(19px);

    }

    .logo {
      display: inline-block;
      height: pxTorem(30px);
      @media screen and (max-width: 600px) {
        height: MpxTorem(26px);
      }
    }

    .maoliang {
      margin-left: pxTorem(20px);
      height: pxTorem(30px);
      @media screen and (max-width: 600px) {
        height: MpxTorem(26px);
      }
    }

    .text {
      display: inline-block;
      //margin-left: pxTorem(80px);
      vertical-align: middle;
      text-align: center;
      color: #fff;
      //margin-top: pxTorem(-7px);

      @media screen and (max-width: 600px) {
        width: 100%;
        margin-left: 0;
        margin-top: MpxTorem(24px);
      }

      .item {
        margin-bottom: pxTorem(10px);
        font-size: pxTorem(9.63px);
        a {
          padding: 0 pxTorem(15px);
          cursor: pointer;
          color: #fff;
          margin-bottom: pxTorem(5px);
          &:not(:last-child) {
            border-right: 1px solid #fff;
          }

          &:hover {
            color: #f5ed00;
          }

          @media screen and (max-width: 600px) {
            font-size: MpxTorem(8px);
            line-height: MpxTorem(20px);
          }
        }
      }

      .box {
        font-size: pxTorem(10px);
        margin-bottom: pxTorem(5px);

        @media screen and (max-width: 600px) {
          font-size: MpxTorem(7px);
        }
        
      }

      .copyright {
        font-size: pxTorem(10px);

        p:not(:last-child) {
          margin-bottom: pxTorem(1px);
        }

        @media screen and (max-width: 600px) {
          font-size: MpxTorem(7px);
        }
      }
    }
  }
</style>
